// Typed axios wrappers around /api/v1/admin/invoices/* — used by the admin
// invoice pages instead of going through Refine's simple-rest provider
// (response shapes don't match Refine's defaults and we don't need its
// optimistic cache here).

import type {
  PublicInvoice,
  InvoiceStatus,
  MarkPaidRequest,
  CreateInvoiceRequest,
} from '@residenone/shared';
import { api } from './api-client';

export type { PublicInvoice, InvoiceStatus, MarkPaidRequest, CreateInvoiceRequest };

export interface ListInvoicesParams {
  limit?: number;
  cursor?: string;
  status?: InvoiceStatus;
  since?: string;     // 'YYYY-MM-DD'
  unit_id?: string;
}

export async function listInvoices(
  params: ListInvoicesParams,
): Promise<{ items: PublicInvoice[]; nextCursor: string | null }> {
  const { data } = await api.get<{ items: PublicInvoice[]; nextCursor: string | null }>(
    '/admin/invoices',
    { params },
  );
  return data;
}

export async function getInvoice(id: string): Promise<PublicInvoice> {
  const { data } = await api.get<{ invoice: PublicInvoice }>(`/admin/invoices/${id}`);
  return data.invoice;
}

export async function createInvoice(input: CreateInvoiceRequest): Promise<PublicInvoice> {
  const { data } = await api.post<{ invoice: PublicInvoice }>('/admin/invoices', input);
  return data.invoice;
}

export async function voidInvoice(id: string, reason: string): Promise<PublicInvoice> {
  const { data } = await api.post<{ invoice: PublicInvoice }>(
    `/admin/invoices/${id}/void`,
    { reason },
  );
  return data.invoice;
}

export async function markInvoicePaid(
  id: string,
  input: MarkPaidRequest,
): Promise<{ invoice: PublicInvoice; payment_id: string }> {
  const { data } = await api.post<{ invoice: PublicInvoice; payment_id: string }>(
    `/admin/invoices/${id}/mark-paid`,
    input,
  );
  return data;
}
